module.exports = __webpack_public_path__ + "static/img/page22.e1fba3a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page22.gif
// module id = A8LZ
// module chunks = 0